(function(root){
  'use strict';
  function mount(){
    root.HywellBundleReviewsCleanup?.();
    const doc=root.document,reviews=doc.querySelector('#customer-reviews');
    if(!reviews)return;
    const $=selector=>reviews.querySelector(selector);
    const viewport=$('.customer-review-viewport'),group=$('[data-reviews-group]');
    const dialog=doc.querySelector('#customer-review-dialog');
    const zoomDialog=doc.querySelector('#customer-photo-dialog'),stage=zoomDialog.querySelector('.customer-photo-stage');
    const photo=zoomDialog.querySelector('[data-photo-image]'),level=zoomDialog.querySelector('[data-photo-level]');
    const controller=new AbortController(),signal=controller.signal;
    const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal});
    const motion=root.matchMedia?.('(prefers-reduced-motion: reduce)');
    const now=()=>root.performance.now();
    const copy=group.cloneNode(true);
    copy.removeAttribute('data-reviews-group');copy.setAttribute('data-reviews-copy','');copy.setAttribute('aria-hidden','true');
    copy.querySelectorAll('button,a').forEach(el=>el.tabIndex=-1);group.after(copy);
    let hovered=false,focused=false,keyboard=false,touching=false;
    let cycle=0,cardStep=344,offset=viewport.scrollLeft,lastTime=null,frame,tween,holdUntil=0;
    let drag,ignoreClick=false,clickTimer,opener,savedPosition,htmlStyle;
    const scrollPage=()=>doc.scrollingElement||doc.documentElement;
    const normalise=value=>cycle?((value%cycle)+cycle)%cycle:value;
    function measure(){
      cycle=group.getBoundingClientRect().width;
      cardStep=(group.querySelector('article')?.getBoundingClientRect().width||320)+(parseFloat(root.getComputedStyle(group).columnGap)||24);
    }
    const resize=typeof ResizeObserver==='function'?new ResizeObserver(()=>{measure();paintPhoto();}):null;
    resize?.observe(group);resize?.observe(stage);measure();
    function updateMotion(){reviews.classList.toggle('is-reduced-motion',!!motion?.matches);}
    motion?.addEventListener?.('change',updateMotion,{signal});updateMotion();
    // A mouse-restored focus is different from a keyboard reader's focus.
    on(doc,'pointerdown',()=>{keyboard=false;focused=false;},{capture:true});
    on(doc,'keydown',event=>{
      if(['Tab','Enter',' ','ArrowLeft','ArrowRight'].includes(event.key)){
        keyboard=true;focused=viewport.contains(doc.activeElement);
      }
    },{capture:true});
    on(viewport,'focusin',()=>{focused=keyboard;});
    on(viewport,'focusout',event=>{focused=keyboard&&viewport.contains(event.relatedTarget);});
    on(viewport,'pointerenter',event=>{if(event.pointerType!=='touch')hovered=true;});
    on(viewport,'pointerleave',()=>{hovered=false;});
    on(viewport,'wheel',event=>{if(Math.abs(event.deltaX)>0)holdUntil=now()+3500;},{passive:true});
    on(viewport,'touchmove',()=>{holdUntil=now()+3500;},{passive:true});
    on(viewport,'dragstart',event=>event.preventDefault());
    function browse(direction){
      measure();if(!cycle)return;
      let start=normalise(viewport.scrollLeft);
      if(direction<0&&start<cardStep)start+=cycle;
      viewport.scrollLeft=start;offset=start;
      const end=start+direction*cardStep;
      if(motion?.matches||!root.requestAnimationFrame){offset=normalise(end);viewport.scrollLeft=offset;}
      else tween={start,end,at:now(),duration:280};
      holdUntil=now()+1800;
    }
    on($('[data-reviews-prev]'),'click',()=>browse(-1));
    on($('[data-reviews-next]'),'click',()=>browse(1));
    on(viewport,'keydown',event=>{
      if(event.target!==viewport||!['ArrowLeft','ArrowRight'].includes(event.key))return;
      event.preventDefault();browse(event.key==='ArrowLeft'?-1:1);
    });
    on(viewport,'pointerdown',event=>{
      if(event.pointerType==='touch'){touching=true;tween=null;holdUntil=now()+3500;return;}
      if(event.button!==0)return;
      tween=null;drag={id:event.pointerId,x:event.clientX,scroll:normalise(viewport.scrollLeft),moved:false};
    });
    on(viewport,'pointermove',event=>{
      if(!drag||event.pointerId!==drag.id)return;
      const distance=event.clientX-drag.x;
      if(!drag.moved&&Math.abs(distance)<6)return;
      if(!drag.moved){
        drag.moved=true;viewport.classList.add('is-dragging');
        if(distance>0&&drag.scroll<cardStep)drag.scroll+=cycle;
        viewport.setPointerCapture?.(event.pointerId);
      }
      event.preventDefault();viewport.scrollLeft=drag.scroll-distance;offset=viewport.scrollLeft;
    });
    function endDrag(event){
      if(event.pointerType==='touch'){touching=false;holdUntil=now()+3500;return;}
      if(!drag||event.pointerId!==drag.id)return;
      if(drag.moved){
        ignoreClick=true;root.clearTimeout(clickTimer);clickTimer=root.setTimeout(()=>{ignoreClick=false;},0);
        offset=normalise(viewport.scrollLeft);viewport.scrollLeft=offset;
        if(viewport.hasPointerCapture?.(event.pointerId))viewport.releasePointerCapture(event.pointerId);
      }
      drag=null;viewport.classList.remove('is-dragging');
    }
    on(viewport,'pointerup',endDrag);on(viewport,'pointercancel',endDrag);
    on(reviews,'click',event=>{
      if(ignoreClick&&event.target.closest('.customer-review-card')){event.preventDefault();event.stopImmediatePropagation();}
    },{capture:true});
    function lockPage(){
      const html=doc.documentElement;
      htmlStyle={overflow:html.style.overflow,gutter:html.style.scrollbarGutter};
      html.style.scrollbarGutter='stable';html.style.overflow='hidden';
    }
    function unlockPage(){
      if(!htmlStyle)return;
      doc.documentElement.style.overflow=htmlStyle.overflow;doc.documentElement.style.scrollbarGutter=htmlStyle.gutter;htmlStyle=null;
    }
    on(reviews,'click',event=>{
      const trigger=event.target.closest('[data-customer-review-open]');if(!trigger)return;
      const card=group.querySelector(`[data-review-index="${trigger.dataset.customerReviewOpen}"]`);if(!card)return;
      const image=card.querySelector('img'),stars=card.querySelector('.customer-review-stars');
      dialog.querySelector('[data-review-image]').src=image.src;dialog.querySelector('[data-review-image]').alt=image.alt;
      dialog.querySelector('h2').textContent=card.querySelector('.customer-review-author strong').textContent;
      dialog.querySelector('[data-review-quote]').textContent=card.querySelector('.customer-review-quote').textContent;
      dialog.querySelector('[data-review-stars]').innerHTML=stars.innerHTML;
      dialog.querySelector('[data-review-stars]').setAttribute('aria-label',stars.getAttribute('aria-label'));
      dialog.querySelector('[data-review-verified]').hidden=!card.querySelector('.customer-review-verified');
      const product=card.querySelector('.customer-review-product'),detail=dialog.querySelector('[data-review-product]');
      detail.href=product.href;detail.innerHTML=product.innerHTML;
      dialog.querySelector('[data-review-zoom]').setAttribute('aria-label',`Enlarge ${dialog.querySelector('h2').textContent}'s photo`);
      opener=trigger;savedPosition={top:scrollPage().scrollTop,left:scrollPage().scrollLeft,rail:viewport.scrollLeft};
      tween=null;lockPage();if(!dialog.open)dialog.showModal();
    });
    on(dialog.querySelector('[data-customer-close]'),'click',()=>dialog.close());
    on(dialog,'cancel',event=>{event.preventDefault();dialog.close();});
    on(dialog,'click',event=>{
      if(event.target!==dialog)return;
      const r=dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
    });
    on(dialog,'close',()=>{
      if(zoomDialog.open)zoomDialog.close();unlockPage();
      const target=opener?.closest('[data-reviews-copy]')?viewport:opener;
      if(target?.isConnected)target.focus({preventScroll:true});
      if(savedPosition){
        viewport.scrollLeft=savedPosition.rail;offset=savedPosition.rail;
        scrollPage().scrollLeft=savedPosition.left;scrollPage().scrollTop=savedPosition.top;
      }
      hovered=viewport.matches(':hover');focused=keyboard&&viewport.contains(doc.activeElement);
    });

    let magnification=100,panX=0,panY=0,pinch;
    const pointers=new Map();
    function paintPhoto(){
      const scale=magnification/100;
      const limitX=Math.max(0,(photo.clientWidth*scale-stage.clientWidth)/2);
      const limitY=Math.max(0,(photo.clientHeight*scale-stage.clientHeight)/2);
      panX=Math.max(-limitX,Math.min(limitX,panX));panY=Math.max(-limitY,Math.min(limitY,panY));
      photo.style.transform=`translate(-50%,-50%) translate(${panX}px,${panY}px) scale(${scale})`;
      level.value=String(magnification);level.setAttribute('aria-valuetext',`${magnification}% of fitted photo size`);
      zoomDialog.querySelector('[data-photo-reset]').textContent=magnification+'%';
      zoomDialog.querySelector('[data-photo-out]').disabled=magnification<=100;
      zoomDialog.querySelector('[data-photo-in]').disabled=magnification>=400;
      stage.classList.toggle('is-magnified',magnification>100);
    }
    function setZoom(value,point){
      const next=Math.max(100,Math.min(400,Math.round(value)));
      if(point){
        const r=stage.getBoundingClientRect(),x=point.x-r.left-r.width/2,y=point.y-r.top-r.height/2;
        const ratio=next/magnification;panX=x-(x-panX)*ratio;panY=y-(y-panY)*ratio;
      }
      magnification=next;if(next===100){panX=0;panY=0;}paintPhoto();
    }
    on(dialog.querySelector('[data-review-zoom]'),'click',()=>{
      const image=dialog.querySelector('[data-review-image]');photo.src=image.src;photo.alt=image.alt;
      zoomDialog.querySelector('#customer-photo-title').textContent=dialog.querySelector('h2').textContent+'’s photo';
      magnification=100;panX=0;panY=0;pointers.clear();pinch=null;
      zoomDialog.showModal();paintPhoto();stage.focus({preventScroll:true});
    });
    on(photo,'load',paintPhoto);
    on(zoomDialog.querySelector('[data-photo-in]'),'click',()=>setZoom(magnification+25));
    on(zoomDialog.querySelector('[data-photo-out]'),'click',()=>setZoom(magnification-25));
    on(zoomDialog.querySelector('[data-photo-reset]'),'click',()=>setZoom(100));
    on(level,'input',()=>setZoom(Number(level.value)));
    on(zoomDialog.querySelector('[data-photo-close]'),'click',()=>zoomDialog.close());
    on(zoomDialog,'cancel',event=>{event.preventDefault();zoomDialog.close();});
    on(zoomDialog,'close',()=>{pointers.clear();pinch=null;if(dialog.open)dialog.querySelector('[data-review-zoom]').focus({preventScroll:true});});
    on(stage,'wheel',event=>{event.preventDefault();setZoom(magnification*Math.exp(-event.deltaY*.0015),{x:event.clientX,y:event.clientY});},{passive:false});
    on(stage,'dblclick',event=>setZoom(magnification===100?200:100,{x:event.clientX,y:event.clientY}));
    on(stage,'keydown',event=>{
      if(!['+','=','-','0','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))return;
      event.preventDefault();
      if(event.key==='+'||event.key==='=')setZoom(magnification+25);
      else if(event.key==='-')setZoom(magnification-25);
      else if(event.key==='0')setZoom(100);
      else{panX+=event.key==='ArrowRight'?40:event.key==='ArrowLeft'?-40:0;panY+=event.key==='ArrowDown'?40:event.key==='ArrowUp'?-40:0;paintPhoto();}
    });
    const pair=()=>[...pointers.values()].slice(0,2);
    function beginPinch(){
      const [a,b]=pair();if(!b){pinch=null;return;}
      pinch={distance:Math.hypot(b.x-a.x,b.y-a.y),zoom:magnification,x:(a.x+b.x)/2,y:(a.y+b.y)/2,panX,panY};
    }
    on(stage,'pointerdown',event=>{
      if(event.pointerType==='mouse'&&event.button!==0)return;
      event.preventDefault();pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      stage.setPointerCapture?.(event.pointerId);beginPinch();stage.classList.add('is-panning');
    });
    on(stage,'pointermove',event=>{
      const previous=pointers.get(event.pointerId);if(!previous)return;
      event.preventDefault();pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pointers.size>1&&pinch?.distance){
        const [a,b]=pair(),r=stage.getBoundingClientRect();
        const next=Math.max(100,Math.min(400,Math.round(pinch.zoom*Math.hypot(b.x-a.x,b.y-a.y)/pinch.distance)));
        const ratio=next/pinch.zoom;
        panX=(a.x+b.x)/2-r.left-r.width/2-(pinch.x-r.left-r.width/2-pinch.panX)*ratio;
        panY=(a.y+b.y)/2-r.top-r.height/2-(pinch.y-r.top-r.height/2-pinch.panY)*ratio;
        magnification=next;paintPhoto();
      }else{panX+=event.clientX-previous.x;panY+=event.clientY-previous.y;paintPhoto();}
    });
    const endPhotoPointer=event=>{
      pointers.delete(event.pointerId);beginPinch();
      if(stage.hasPointerCapture?.(event.pointerId))stage.releasePointerCapture(event.pointerId);
      if(!pointers.size)stage.classList.remove('is-panning');
    };
    on(stage,'pointerup',endPhotoPointer);on(stage,'pointercancel',endPhotoPointer);
    function advance(time){
      if(!reviews.isConnected)return;
      const elapsed=lastTime===null?0:Math.min(time-lastTime,64);lastTime=time;
      if(tween){
        const progress=Math.min(1,(time-tween.at)/tween.duration),ease=1-Math.pow(1-progress,3);
        offset=tween.start+(tween.end-tween.start)*ease;viewport.scrollLeft=offset;
        if(progress===1){offset=normalise(offset);viewport.scrollLeft=offset;tween=null;}
      }else if(touching||hovered||focused||drag||dialog.open||motion?.matches||doc.hidden||time<holdUntil){offset=viewport.scrollLeft;}
      else if(cycle){offset=normalise(offset+34*elapsed/1000);viewport.scrollLeft=offset;}
      frame=root.requestAnimationFrame?.(advance);
    }
    frame=root.requestAnimationFrame?.(advance);
    root.HywellBundleReviewsCleanup=()=>{
      if(zoomDialog.open)zoomDialog.close();if(dialog.open)dialog.close();unlockPage();
      controller.abort();resize?.disconnect();root.cancelAnimationFrame?.(frame);root.clearTimeout(clickTimer);copy.remove();
    };
  }
  root.BundleCustomerReviews={mount};
})(window);
